import React from 'react'

//component
import SimpleTable from  '@/components/elements/global/tables/SimpleTable/SimpleTable'
import SimplePageSelector from  '@/components/elements/global/PageSelectors/SimplePageSelector';
import NotificationBar from  '@/components/elements/languages/NotificationBar';
import RemoveFromWorkspaceModal from  '@/components/modals/orgSettings/userGroups/RemoveFromWorkspace/RemoveFromWorkspaceModal';

//hooks
import UseUserGroupsWorkspacesTab from './UserGroupsWorkspaces.hooks';

//styling
import "../../../../css/orgSettings/usergroups/workspaces.scss"



const UserGroupsWorkspacesTab = () => {  
    const {noDataMessage, tableContent, isLoading, setPage, paginationSettings, showSimpleTable, notificationDetails, onRemoveAccessClick, showRemoveAccessModal, setShowRemoveAccessModal, workspaceName, userGroupName} = UseUserGroupsWorkspacesTab();

    return(
        <div className="workspaces-tab" data-testid="usergroups-workspaces-tab">
            {showSimpleTable && <SimpleTable isLoading={isLoading} simpleTableContent={tableContent} noDataMessage={noDataMessage} isInfiniteScroll={false}/>}
            
            {paginationSettings?.hasPagination && <SimplePageSelector currentPage={paginationSettings.currentPage} totalPages={paginationSettings.totalPages} setPage={setPage} />}
        
            <RemoveFromWorkspaceModal showModal={showRemoveAccessModal} onRemoveClick={onRemoveAccessClick} onCloseClick={() => setShowRemoveAccessModal(false)} groupname={userGroupName} workspaceName={workspaceName} />

            <NotificationBar show={notificationDetails.show} notificationStatus={notificationDetails.status} msg={notificationDetails.message} />
        </div>
    )
}

export default UserGroupsWorkspacesTab